import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {GiftshopModule} from "./giftshop/giftshop.module";

import { environment } from '../environments/environment';
import * as Sentry from "@sentry/angular";

Sentry.init({
    dsn: "https://12ea3db1b40c4a81b118eea299c4cc36@sentry.twingle.de/5",
    integrations: [Sentry.captureConsoleIntegration({levels: ['error']})],
    ignoreErrors: [
        'Non-Error exception captured',
        'Non-Error promise rejection captured'
    ]
});

if (environment.production) {
    enableProdMode();
}
platformBrowserDynamic().bootstrapModule(GiftshopModule);
